import SearchIcon from '@mui/icons-material/Search';
import { IconButton } from '@mui/material';
import { headerSearchMobileButtonIconSX } from '@/components/content/Header/styles/search';

export const HeaderSearch: React.FC<{
	toggleSearch: (open?: boolean) => () => void;
}> = ({ toggleSearch }) => (
	<IconButton onClick={toggleSearch(true)}>
		<SearchIcon sx={headerSearchMobileButtonIconSX} />
	</IconButton>
);
